export default __webpack_public_path__ + "static/media/Du_Solid_.8ddc6712.png";